/* eslint-disable react-hooks/exhaustive-deps */
import { TitleSection } from "components/styles";
import { Container } from "./styles";
import RegisterSpaceFormFields from "views/Configuracion/SettingsSpaceAdmin/components/RegisterSpaceForm/RegisterSpaceFormFields";
import Footer from "./Footer";
import useSpaceForm from "views/Configuracion/SettingsSpaceAdmin/components/RegisterSpaceForm/utils/hooks/useSpaceForm";
import useToggleSpaceActive from "views/Configuracion/SettingsSpaceAdmin/utils/hooks/useToggleSpaceActive";
import useSaveChangesForm from "views/Configuracion/SettingsSpaceAdmin/utils/hooks/useSaveChangesForm";
import useDeleteSpace from "views/Configuracion/SettingsSpaceAdmin/utils/hooks/useDeleteSpace";
import DialogAlertSuccessRegisterSpace from "views/Configuracion/SettingsSpaceAdmin/components/RegisterSpaceForm/Dialogs/DialogAlertSuccessRegisterSpace/DialogAlertSuccessRegisterSpace";
import DialogAlertConfirmUpdateSpace from "views/Configuracion/SettingsSpaceAdmin/components/RegisterSpaceForm/Dialogs/DialogAlertConfirmUpdateSpace/DialogAlertConfirmUpdateSpace";
import DialogAlertConfirmDeleteSpace from "views/Configuracion/SettingsSpaceAdmin/components/RegisterSpaceForm/Dialogs/DialogAlertConfirmDeleteSpace/DialogAlertConfirmDeleteSpace";
import useSpaceChangeHistory from "views/Configuracion/SettingsSpaceAdmin/utils/hooks/useSpaceChangeHistory";
import ToggleActiveDialogs from "views/Configuracion/SettingsSpaceAdmin/components/RegisterSpaceForm/ToggleActiveDialogs";
import DialogErrorForFutureReservationsInDeletion from "views/Configuracion/SettingsSpaceAdmin/components/RegisterSpaceForm/Dialogs/DialogErrorForFutureReservationsInDeletion";
import DialogErrorForFutureReservationsInEdition from "views/Configuracion/SettingsSpaceAdmin/components/RegisterSpaceForm/Dialogs/DialogErrorForFutureReservationsInEdition";
import CustomDialogAlert from "components/DialogAlert/v2";
import { CloseButton } from "components/ToastMessage/styles";
import useResourcesUniversitySpacesContext from "../../utils/context/useResourcesUniversitySpacesContext";
import { SUCCESS_UPDATE_TOAST_MESSAGE } from "views/Configuracion/SettingsSpaceAdmin/utils/constants";

const RegisterSpaceForm = ({
    dialog,
    spaceSelected,
    data, preselectedData,
    dialogSpaceForm
}) => {
    const { spaceList, loadingRequestOfReservationAction, toastMessage } = useResourcesUniversitySpacesContext();
    const formHandler = useSpaceForm({
        spaceSelected
    });
    const { form, errors } = formHandler;
    const deleteSpaceHandler = useDeleteSpace({
        loadingRequest: loadingRequestOfReservationAction, toastMessage, form,
        onSuccess: spaceId => {
            spaceList.removeSpace(spaceId);
            dialogSpaceForm.hide();
            toastMessage.show(`¡El espacio ${form.value.name} fue eliminado existosamente!`);
        }
    });
    const toggleActiveHandler = useToggleSpaceActive({
        form: formHandler.form,
        loadingRequest: loadingRequestOfReservationAction,
        spaceSelected,
        onSuccess: (newActive, message) => {
            spaceSelected.update({ active: newActive });
            spaceList.updateSpace({
                ...spaceSelected.value,
                active: newActive
            });
            toastMessage.show(message);
            dialog.hide();
        }
    });
    const saveChangeHandler = useSaveChangesForm({
        loadingRequest: loadingRequestOfReservationAction, 
        preselectedData, spaceSelected,
        form, onSuccessUpdate: spaceUpdated => {
            spaceSelected.update(spaceUpdated);
            spaceList.updateSpace(spaceUpdated);
            dialogSpaceForm.hide();
            toastMessage.show(SUCCESS_UPDATE_TOAST_MESSAGE);
        }
    });
    const spaceChangeHistory = useSpaceChangeHistory({
        loadingRequest: loadingRequestOfReservationAction, form: formHandler.form.value
    });
    const getDisabledSaveButton = () => {
        return (
            !form.areThereChanges() ||
            !form.isCompleted() ||
            errors.areThere()
        );
    }
    const {
        dialogSuccessCreate,
        dialogConfirmUpdate,
        dialogErrorForFutureReservationsInEdition
    } = saveChangeHandler.dialogs;
    const {
        dialogConfirmDelete,
        dialogErrorForFutureReservationsInDeletion
    } = deleteSpaceHandler.dialogs;
    return (
        <>
            <CustomDialogAlert dialog={dialog}>
                <CloseButton onClick={dialog.hide} />
                <Container>
                    <TitleSection>{spaceSelected.isEmpty() ? "Registrar" : "Editar"} espacio</TitleSection>
                    <RegisterSpaceFormFields
                        className="custom-scrollbar primary"
                        formHandler={formHandler}
                        data={data}
                        spaceSelected={spaceSelected}
                        toggleActiveHandler={toggleActiveHandler}
                        spaceChangeHistory={spaceChangeHistory} />
                    <Footer
                        formHandler={formHandler}
                        saveChanges={saveChangeHandler.saveChanges}
                        openDialogConfirmDelete={dialogConfirmDelete.open}
                        hideDialogSpaceForm={dialogSpaceForm.hide}
                        getDisabledSaveButton={getDisabledSaveButton} />
                </Container>
            </CustomDialogAlert>
            <DialogAlertSuccessRegisterSpace
                dialog={dialogSuccessCreate}
                spaceName={form.value.name} />
            <DialogAlertConfirmUpdateSpace
                dialog={dialogConfirmUpdate}
                confirm={saveChangeHandler.updateSpace}
                content="Se aplicarán los cambios realizados en el espacio. ¿Deseas continuar?" />
            <DialogAlertConfirmDeleteSpace
                dialog={dialogConfirmDelete}
                confirm={deleteSpaceHandler.deleteSpace} />
            <ToggleActiveDialogs {...toggleActiveHandler} />
            <DialogErrorForFutureReservationsInDeletion
                dialog={dialogErrorForFutureReservationsInDeletion} />
            <DialogErrorForFutureReservationsInEdition
                dialog={dialogErrorForFutureReservationsInEdition} />
        </>
    );
}

export default RegisterSpaceForm;